var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticClass:"main"},[_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('MangoFpSettingsMain')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }